export default {
    methods: {
        getLocalStorageTokens: function() {
            return typeof localStorage.getItem('curlyTokens') !== 'undefined' && localStorage.getItem('curlyTokens') !== null ? JSON.parse( localStorage.getItem('curlyTokens') ) : false
        },
        hasTokens: function(){
            var tokens = this.getLocalStorageTokens()
            return tokens !== false && typeof tokens.expires_in !== 'undefined' && typeof tokens.access_token !== 'undefined' && typeof tokens.refresh_token !== 'undefined'
        },
        isTokenValid: function(){
            var tokens = this.getLocalStorageTokens()
            return this.hasTokens() && tokens.expires_in > Math.round( (new Date().getTime()) / 1000 ) - 10
        },
        getAccessToken: function(){
            var tokens = this.getLocalStorageTokens()
            return this.hasTokens() && this.isTokenValid() ? tokens.access_token : ''
        },
        getRefreshToken: function(){
            var tokens = this.getLocalStorageTokens()
            console.log('token validation', this.isTokenValid())
            console.log('has tokens', this.hasTokens())
            return this.hasTokens() && this.isTokenValid() === false ? tokens.refresh_token : ''
        }
    }
}